import { render, staticRenderFns } from "./CustomOfferByCategory.vue?vue&type=template&id=9799e17e&scoped=true&"
import script from "./CustomOfferByCategory.vue?vue&type=script&lang=js&"
export * from "./CustomOfferByCategory.vue?vue&type=script&lang=js&"
import style0 from "./CustomOfferByCategory.vue?vue&type=style&index=0&id=9799e17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9799e17e",
  null
  
)

export default component.exports